/* eslint-disable */
import axios from "axios";

export default {
  methods: {
    /**
     * Traz combo de Publico Alvo
     * @param {Number} id
     * @return {
     *   "tipoServicoPublico": [
     *   {
     *    "id": 0,
     *    "tipoServicoPublico": "string"
     *   }
     *  ]
     * }
     */
    getPublicoAlvo(tipoServicoId) {
      return axios.get(
        this.CriarUrl({
          resource: `servico_publico?rnpTipoFormulario=Form_Hospital&tipoServico=${tipoServicoId}`
        })
      );
    },
    /**
     * Traz combo de Especialidades
     * @param {Number} id
     * @return {
     *   "tipoServicoEspecialidade": [
     *   {
     *    "id": 0,
     *    "tipoServicoEspecialidade": "string"
     *   }
     *  ]
     * }
     */
    getEspecialidades(tipoServicoId) {
      return axios.get(
        this.CriarUrl({
          resource: `servico_especialidade?rnpTipoFormulario=Form_Hospital&tipoServico=${tipoServicoId}`
        })
      );
    },
    /**
     * Traz combo de Abrangencia
     * @param {Number} id
     * @return {
     *   "tipoServicoAbrangencia": [
     *   {
     *    "id": 0,
     *    "tipoServicoAbrangencia": "string"
     *   }
     *  ]
     * }
     */
    getAbrangencia(tipoServicoId) {
      return axios.get(
        this.CriarUrl({
          resource: `servico_abrangencia?rnpTipoFormulario=Form_Hospital&tipoServico=${tipoServicoId}`
        })
      );
    },
    /**
     * Traz combo de Abrangencia
     * @param {Number} id
     * @return {
     *   "tipoServicoAbrangencia": [
     *   {
     *    "id": 0,
     *    "tipoServicoAbrangencia": "string"
     *   }
     *  ]
     * }
     */
    getExames(tipoServicoId) {
      return axios.get(
        this.CriarUrl({
          resource: `servico_abrangencia?rnpTipoFormulario=Form_Hospital&tipoServico=${tipoServicoId}`
        })
      );
    },
    /**
     * Traz servicos
     */
    getServicos() {
      return axios.get(
        this.CriarUrl({
          resource: `servico?rnpTipoFormulario=Form_Hospital`
        })
      );
    },
    getQuestionario(id) {
      return axios.get(
        this.CriarUrl({
          resource: `questionario?rnpPrestadorId=${id}`
        })
      );
    }
  }
};
